import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Slider from 'react-slick';
import { ArrowRight32, ArrowLeft32 } from '@carbon/icons-react';
import Image from '../../image';
import ErrorBoundary from '../../../error-boundary';

class ParagraphPageTitle extends Component {

  state = {
    sliderSettings: {
      adaptiveHeight: true,
      arrows: false,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000
    },
    icons: window.generalConfig
  }

  render() {
    const { content } = this.props;

    return (
      <section>
        <div className="slider-section-page-title">
          <ErrorBoundary>
            <Slider {...this.state.sliderSettings}>
            {content.fieldBilder.map((item, index) => {
              return (
                <div key={index}>
                  <Image
                    data={item.entity.fieldMediaImage}
                    credit={item.entity.fieldCredit}
                    caption={item.defaultCaption === false ?
                      item.customCaption : null}
                  />
                </div>
              );
            })}
          </Slider>
          </ErrorBoundary>
        </div>
        <div className="wrapper-content">
          <div className="svg-wrapper">
            {content.fieldMenuIconsAnzeigen && this.state.icons &&
            <>
              {(this.state.icons.fieldKlecks1.entity != null && this.state.icons.fieldLink1 != null) &&
              <a className="first sub-icon" href={this.state.icons.fieldLink1.url.path}>
                <img src={this.state.icons.fieldKlecks1.entity.fieldMediaImage.url} alt=""/>
              </a>
              }
              {(this.state.icons.fieldKlecks2.entity != null &&
                this.state.icons.fieldLink2 != null) &&
              <a className="second sub-icon"
                 href={this.state.icons.fieldLink2.url.path}>
                <img
                  src={this.state.icons.fieldKlecks2.entity.fieldMediaImage.url}
                  alt=""/>
              </a>
              }
              {(this.state.icons.fieldKlecks3.entity != null &&
                this.state.icons.fieldLink3 != null) &&
              <a className="third sub-icon"
                 href={this.state.icons.fieldLink3.url.path}>
                <img
                  src={this.state.icons.fieldKlecks3.entity.fieldMediaImage.url}
                  alt=""/>
              </a>
              }
              {(this.state.icons.fieldKlecks4.entity != null &&
                this.state.icons.fieldLink4 != null) &&
              <a className="fourth sub-icon"
                 href={this.state.icons.fieldLink4.url.path}>
                <img
                  src={this.state.icons.fieldKlecks4.entity.fieldMediaImage.url}
                  alt=""/>
              </a>
              }
            </>
            }
          </div>
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-12 content-wrapper">
                <div className="content">
                  <h1 className="h1">{content.fieldHeading}</h1>
                  {!!content.fieldHint &&
                    <div className="h1 subtitle" dangerouslySetInnerHTML={{__html: content.fieldHint.value}}/>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
    );
  }
}

ParagraphPageTitle.propTypes = {
  content: PropTypes.object.isRequired
};

export default ParagraphPageTitle;
